<template>
  <div>
    <PageHeader
      v-if="isAuthenticated"
      :currentApp="$store.getters.getCurrentApp"
    />
    <SubNav v-if="isAuthenticated" />
    <router-view v-if="isAuthenticated" />
    <div
      v-if="visibleBanner"
      class="alert alert-dark text-center mb-0 banner browserWarning"
      role="alert"
    >
      OBS: Verktyget är optimerat för Chrome browser
      NOTE: This tool is optimized for Chrome browser

      <button
        type="button"
        class="btn btn-primary btn-sm ms-3 browserBannerBtn"
        @click="hideBrowserBanner()"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
import SubNav from "./SubNav/SubNav";
import PageHeader from "./PageHeader/PageHeader";
import { fetchFormFieldData } from "../../api/api.js";
import globalConfig from "@/mixins/globalConfig";
import appsConfig from "./PageHeader/appsConfig.js";

export default {
  name: "Layout",
  components: {
    SubNav,
    PageHeader
  },
  mixins: [globalConfig],
  data() {
    return {
      visibleBanner: false,
      isAuthenticated: false
    };
  },
  async mounted() {
    this.initializeBanner();
    await this.loadGlobalConfigFromFile();
  },
  methods: {
    initializeBanner() {
      if (
        localStorage.getItem("browserBanner") == null &&
        !this.$browserDetect.isChrome
      )
        this.visibleBanner = true;
    },
    hideBrowserBanner() {
      localStorage.setItem("browserBanner", true);
      this.visibleBanner = false;
    },
    toastMessage(message, closeButton) {
      if (closeButton) {
        const h = this.$createElement;

        const vNodesMsg = h("b", { class: ["text-center", "mb-0"] }, [
          "Problem fetching default date from the server. The service will not function correctly.",
          h(
            "b-button",
            {
              class: ["float-right", "btn-sm", "mr-3"],
              on: {
                click: () => this.$bvToast.hide("toast")
              }
            },
            "Close"
          )
        ]);

        this.$bvToast.toast([vNodesMsg], {
          id: "toast",
          title: "Warning",
          variant: "danger",
          solid: true,
          noCloseButton: true,
          autoHideDelay: 300000
        });
      } else {
        this.$bvToast.toast(message, {
          title: "Warning",
          variant: "warning",
          solid: true,
          noCloseButton: false
        });
      }
    },
    setApplicationAccess(applications) {
      let broadcastAccess =
        applications.filter(application =>
          application.applicationName.includes("tv-analys")
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "broadcast"
      ).userAccess = broadcastAccess;
      let onlineVideoAccess =
        applications.filter(application =>
          application.applicationName.includes("online")
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "online-video"
      ).userAccess = onlineVideoAccess;
      let crossPlatformAccess =
        applications.filter(
          application => application.applicationName == "total-analys"
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "cross-platform"
      ).userAccess = crossPlatformAccess;
      let videoInHomeAccess =
        applications.filter(
          application => application.applicationName == "video-in-home"
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "video-in-home"
      ).userAccess = videoInHomeAccess;
    }
  },
  async created() {
    // Determine the current app based on subdomain
    this.$store.dispatch("determineVideoInHomeSubdomain");

    // Get token and user from URL params or localStorage
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get("token");
    let user = urlParams.get("user");

    if (token === null) {
      token = localStorage.getItem("accessToken");
      user = localStorage.getItem("user");
    }

    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", user);

    this.$store.commit("setLoggedIn", true);
    this.$store.commit("setUser", user);
    this.$store.commit("setAccessToken", token);

    try {
      const userData = await fetchFormFieldData("User");
      this.setApplicationAccess(userData.applications);

      this.$store.commit("setInternalAndMMSOnly", userData.internalAndMMSOnly);
      localStorage.setItem("user", userData.email);
      this.$store.commit("setUser", userData.email);

      // Set up user access permissions
      userData.applications.forEach(app => {
        switch (app.applicationName) {
          case "tv-analys-light":
            this.$store.commit("setLightAccess", true);
            break;
          case "tv-analys-annonsör":
            this.$store.commit("setAdvertiserAccess", true);
            break;
          case "tv-analys":
            this.$store.commit("setFullAccess", true);
            break;
          case "mms-användare":
            this.$store.commit("setMmsUser", true);
            break;
          case "video-in-home":
            this.$store.commit("setVideoInHomeAccess", true);
            break;
        }
      });

      // Check permission based on the current app
      let hasAccess = false;

      if (this.$store.getters.getCurrentApp === "video-in-home") {
        // For VIDEO IN HOME app, check videoInHomeAccess
        hasAccess = this.$store.state.systemInfo.videoInHomeAccess;
      } else {
        // For BROADCAST app, check any of the TV analysis access levels
        hasAccess =
          this.$store.state.systemInfo.lightAccess ||
          this.$store.state.systemInfo.advertiserAccess ||
          this.$store.state.systemInfo.fullAccess;
      }

      if (!hasAccess) {
        // Redirect to login if user doesn't have access
        const currentUrl = window.location.href;
        window.location.href =
          this.config_WebCaatAuthWebUrl +
          "?returnUrl=" +
          encodeURIComponent(currentUrl);
      } else {
        // User is authenticated and has access
        this.isAuthenticated = true;
      }
    } catch (error) {
      if (error.response?.status !== 401) {
        this.toastMessage("A problem occurred while fetching the user.", false);
      }
      console.error(error);

      // Redirect to login on error
      const currentUrl = window.location.href;
      window.location.href =
        this.config_WebCaatAuthWebUrl +
        "?returnUrl=" +
        encodeURIComponent(currentUrl);
    }
  }
};
</script>

<style scoped>
.banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  border-radius: 0;
  background: #424851;
}

.browserWarning {
  color: red;
}

.browserBannerBtn {
  float: right;
  background: #97d058;
  border: none;
}
</style>
